import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ContactForm() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const words = ["Planen", "Sie", "Ihr"];
  return <section id="contactform" ref={ref} className={cn("relative w-full py-16 md:py-24 overflow-hidden transition-opacity duration-700", "!bg-[hsl(90,61%,26%)]", isVisible ? "opacity-100" : "opacity-0")}>
      {/* Hintergrund-Deko */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 -left-16 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-80 w-80 rounded-full bg-black/20 blur-3xl" />
      </div>

      <div className="relative max-w-5xl mx-auto px-4 md:px-8">
        {/* Card Wrapper mit Rahmen + Shadow */}
        <div className={cn("relative rounded-3xl border border-white/15 bg-white/5", "backdrop-blur-md shadow-[0_18px_60px_rgba(0,0,0,0.45)]", "px-6 py-10 md:px-10 md:py-12", "transition-transform transition-shadow duration-700", isVisible ? "translate-y-0" : "translate-y-4")}>
          {/* Glow-Ring um die Karte */}
          <div className="pointer-events-none absolute -inset-[2px] rounded-3xl bg-gradient-to-r from-lime-300/40 via-emerald-400/40 to-lime-200/40 opacity-0 blur-xl transition-opacity duration-700 group-hover:opacity-100" />

          {/* Inhalt */}
          <div className="relative z-10 text-center">
            {/* Heading */}
            <h2 className="text-4xl md:text-5xl font-display font-extrabold text-white leading-tight mb-5">
              {words.map((word, i) => <span key={`${word}-${i}`} className={cn("inline-block mr-3", "transition-all duration-500 will-change-transform", isVisible ? "translate-y-0 opacity-100 scale-100" : "translate-y-6 opacity-0 scale-90")} style={{
              transitionDelay: isVisible ? `${i * 90}ms` : "0ms"
            }} data-index={i}>
                  {word}
                </span>)}

              {/* „Event“ mit extra Styling + Underline */}
              <span className={cn("inline-block relative text-black", "transition-all duration-700 will-change-transform", isVisible ? "translate-y-0 opacity-100 scale-110" : "translate-y-8 opacity-0 scale-80")} style={{
              transitionDelay: isVisible ? "260ms" : "0ms",
              textShadow: isVisible ? "0 0 20px rgba(0,0,0,0.45)" : "0 0 0 rgba(0,0,0,0)"
            }}>
                <span className={cn("inline-block", "transition-[transform] duration-[900ms] ease-out", isVisible ? "rotate-0" : "-rotate-3")}>
                  Event
                </span>

                {/* animierter Underline-Rahmen unter „Event“ */}
                <span className={cn("pointer-events-none absolute -bottom-1 left-0 right-0 mx-auto h-[3px] rounded-full bg-gradient-to-r from-lime-300 via-emerald-400 to-lime-200", "transition-transform transition-opacity duration-700 origin-center", isVisible ? "scale-x-100 opacity-100" : "scale-x-0 opacity-0")} style={{
                transitionDelay: isVisible ? "420ms" : "0ms"
              }} />
              </span>
            </h2>

            {/* Text */}
            <p className={cn("text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed transition-all duration-700", isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0")} style={{
            transitionDelay: isVisible ? "500ms" : "0ms"
          }}>
              Ob private Feier, berufliche Veranstaltung oder Hochzeit. Wir
              gestalten unvergessliche kulinarische Erlebnisse. Füllen Sie das
              Formular aus und wir erstellen ein maßgeschneidertes Angebot für
              Ihren besonderen Anlass.
            </p>

            {/* Form (Shortcode) */}
            <div className={cn("mt-10 transition-all duration-700", isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0")} style={{
            transitionDelay: isVisible ? "580ms" : "0ms"
          }}>
              <div className={cn("mx-auto w-full max-w-4xl", "rounded-2xl border border-white/20 bg-black/10 p-4 md:p-6", "backdrop-blur-sm shadow-inner")}>
                [forminator_form id="465"]
              </div>
            </div>

            {/* Bottom gradient line */}
            <div className={cn("mt-10 mx-auto h-px max-w-md transition-all duration-700", isVisible ? "w-full opacity-100" : "w-0 opacity-0")} style={{
            transitionDelay: isVisible ? "650ms" : "0ms",
            background: "linear-gradient(to right, transparent, rgba(255,255,255,0.8), transparent)"
          }} />
          </div>
        </div>
      </div>
    </section>;
}